import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import FilterValuesTableActions from '../FilterValuesTableActions/FilterValuesTableActions';
import { IFilterValue } from '@/models/filters.model';
import { DEFAULT_LOCALE } from '@/models/localization.model';

type TGetPartnersTableColumns = {
  t: TFunction;
  canManage: boolean;
  onFilterValueDelete: (filterValue: IFilterValue) => void;
  onFilterValueEdit: (filterValue: IFilterValue) => void;
};

export const getFilterValuesTableColumns = ({
  t,
  canManage,
  onFilterValueDelete,
  onFilterValueEdit,
}: TGetPartnersTableColumns): ColumnsType<IFilterValue> => [
  {
    title: t('filter_values_value_uk'),
    dataIndex: 'value_uk',
    key: 'value_uk',
    render: (_, record) => <span>{record.locale?.[DEFAULT_LOCALE]?.title ?? '—'}</span>,
  },
  {
    title: t('filter_values_value_ru'),
    dataIndex: 'value_ru',
    key: 'value_ru',
    render: (_, record) => <span>{record.locale?.ru?.title ?? '—'}</span>,
  },
  {
    title: t('filter_values_value_alias'),
    dataIndex: 'slug',
    key: 'slug',
    render: (slug) => <span>{slug}</span>,
  },
  ...(canManage
    ? [
        {
          title: t('filter_values_actions'),
          key: 'actions',
          render: (_: unknown, record: IFilterValue) => (
            <FilterValuesTableActions onDelete={onFilterValueDelete} onEdit={onFilterValueEdit} record={record} />
          ),
        },
      ]
    : []),
];
